/**
 * Parses a field's `parametres` option list into an array of options.
 *
 * The backend now stores option lists as a JSON array string
 * (e.g. `["Forfaitaire","Frais réel","Sans frais"]`). Older records may still
 * use the legacy comma-separated format (`Forfaitaire,Frais réel,Sans frais`),
 * so we fall back to splitting on commas when the value isn't valid JSON.
 */
export const parseParametresOptions = (
  parametres?: string | null,
): string[] => {
  if (!parametres) return [];
  try {
    const parsed = JSON.parse(parametres);
    if (Array.isArray(parsed)) {
      return parsed.map((item) => String(item));
    }
  } catch {
    // Not JSON — fall back to the legacy comma-separated format.
  }
  return parametres.split(',');
};
